interface LogoProps {
  compact?: boolean;
}

function Logo({ compact = false }: LogoProps) {
  return (
    <div className={`dh-brand ${compact ? 'compact' : ''}`} aria-label="DRUM Hi">
      <span>DRUM</span>
      <b>Hi</b>
      <i />
    </div>
  );
}

export default Logo;
